// api list
// dev 环境会将 value 转成 key，在添加代理
export const apiMap = {
    apiXs: 'https://xiaoshuo.wtzw.com',
    apiGw: 'https://api-gw.wtzw.com',
    apiBc: 'https://api-bc.wtzw.com',
    apiCmnt: 'https://api-cmnt.wtzw.com',
    apiCfg: 'https://api-cfg.wtzw.com',
    apiMa: 'https://api-marathon.wtzw.com',
    // apiMa: 'http://172.16.78.141:8080',
};

// 版本功能支持map
export const actionSupportMap = {
    // 侧边栏
    sidePanel: {
        android: 0,
        ios: Infinity,
        harmonyos: Infinity,
    },
};
